import { tUnchecked } from '@glow/language'
import { IconFa } from '@glow/ui-components'
import { ReactNode } from 'react'
import { AiAnswer, useLocalizeLabels } from './AiAnswer'
import { AiCopyButton } from './AiCopyButton'
import { AiFeedbackRow } from './AiFeedbackRow'
import { AiLogo } from './AiLogo'
import { AiSources } from './AiSources'
import { AiChatMessage, AiToolActivity } from './useAiChat'

// Tools the drawer knows get their own wording; anything else falls back to a generic line,
// so a tool added server-side is visible before it gets dedicated copy here
const toolActivityLabel = ({ tool, detail, done }: AiToolActivity): string =>
  tUnchecked(
    [`aiChat.tools.${tool}.${done ? 'used' : 'running'}`, `aiChat.tools.fallback.${done ? 'used' : 'running'}`],
    { detail }
  )

export const AiChatTurn = ({
  message,
  streaming,
  thinking,
  onRate,
  onComment
}: {
  message: AiChatMessage
  streaming: boolean
  thinking: ReactNode
  onRate: (messageId: string, helpful: boolean) => void
  onComment: (messageId: string, comment: string) => void
}) => {
  const localize = useLocalizeLabels()
  return message.role === 'user' ? (
    <div className="max-w-17/20 self-end rounded-lg rounded-br-sm bg-primary-050 px-3 py-2 text-sm text-emphasis-high">
      {message.text}
    </div>
  ) : (
    <div className="max-w-9/10 self-start">
      {message.toolActivity.map((activity) => (
        <div key={activity.id} className="mb-1 flex items-center gap-1.5 text-xs text-emphasis-medium">
          {activity.done ? (
            <IconFa icon={['far', 'check']} size="sm" />
          ) : (
            <AiLogo size={14} className="animate-pulse text-primary-500" />
          )}
          <span>{toolActivityLabel(activity)}</span>
        </div>
      ))}
      <AiAnswer text={message.text} streaming={streaming} thinking={thinking} labelKeys={message.labelKeys} />
      {/* Rendered while streaming too: sources arrive before the first token */}
      <AiSources sources={message.sources} />
      {!streaming && message.exchangeId && <AiFeedbackRow message={message} onRate={onRate} onComment={onComment} />}
      {!streaming && !message.exchangeId && message.text && (
        <div className="mt-1 flex items-center gap-1">
          <AiCopyButton text={localize(message.text, message.labelKeys)} />
        </div>
      )}
    </div>
  )
}
